export default __webpack_public_path__ + "static/media/tooltip.2e8aaf3b.less";